<template>
  <div class="table-row__wrapper">
    <div
      :class="['table-row', {'clickable': clickableRows}]"
      @click.stop="clickHandler"
    >
      <Cell
        v-for="(cell, index) in configuredData.rowData"
        :key="index"
        :delete-column="cell.type === 'delete'"
        :cell-data="cell"
        :show-expand-icon="hasChildren"
        :expanded="expanded"
        :style="hasChildren ? 'width: 100%;' : cell.columnWidth"
        @toggle-expanded="toggleExpand"
        @delete="deleteHandler"
        @btn-click="btnClickHandler(cell)"
      />
    </div>
    <div
      v-if="expanded"
      class="table-row__children"
    >
      <Row
        v-for="(child, index) in configuredData.children"
        :key="index"
        :config="config"
        :row-data="child"
        :clickable-rows="clickableRows"
        @parent-click="(val) => $emit('parent-click', val)"
        @row-click="(val) => $emit('row-click', val)"
      />
    </div>
  </div>
</template>

<script>
/**
 * Строка таблицы
 * @module Shared/Component/Table/Row
 * @requires Shared/Table/Cell
 * @vue-prop {Array} config - конфигурация таблицы
 * @vue-prop {Array} rowData - данные для отображения
 * @vue-prop {Boolean} clickableRows - кликабельны ли строки
 * @vue-data {Boolean} expanded - показаны наследники
 * @vue-computed {Array} configuredData - сконфигурированный конфиг
 * @vue-computed {Boolean} hasChildren - есть ли наследники
 * */

import Cell from 'Shared/Table/Cell'

export default {
  name: 'Row',
  components: {
    Cell
  },
  props: {
    config: {
      type: Array,
      default: () => []
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    clickableRows: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    expanded: false
  }),
  computed: {
    configuredData() {
      const configuredRowData = []
      this.config.forEach(configElement => {
        const value = ![undefined, null].some(el => el === this.rowData[configElement.field])
          ? this.rowData[configElement.field]
          : configElement.value

        if ((this.hasChildren && configElement.extandable) || !configElement.hidden) {
          configuredRowData.push({
            value,
            extandable: configElement.extandable,
            columnWidth: configElement.columnWidth,
            type: configElement.type,
            format: configElement.format
          })
        }
      })

      return {
        rowData: configuredRowData,
        children: this.rowData.children
      }
    },
    hasChildren() {
      return this.rowData.children && this.rowData.children.length > 0
    }
  },
  methods: {
    /**
     * Обработчик открытия\скрытия наследников
     */
    toggleExpand() {
      this.expanded = !this.expanded
    },
    /**
     * Обработчик клика по строке
     */
    clickHandler() {
      this.$emit(`${this.hasChildren ? 'parent' : 'row'}-click`, this.rowData)
    },
    /**
     * Обработчик клика по кнопке
     */
    btnClickHandler(cell) {
      this.$emit('btn-click', {
        cell,
        row: this.rowData
      })
    },
    /**
     * Обработчик клика по иконке удаления
     */
    deleteHandler() {
      this.$emit('delete-row', this.rowData)
    }
  }
}
</script>

<style lang="scss" scoped>
.table-row {
  display: flex;
  align-items: stretch;

  &.clickable {
    cursor: pointer;
  }

  &__children {
    &::v-deep {
      .cell__wrapper:nth-child(1) {
        .cell {
          margin-left: 10px;
          width: calc(100% - 10px);
        }
      }
    }
  }
}
</style>
